<template>
  <v-ons-page>
    <v-ons-navigator
      id="navigator"
      var="navigator"
      swipeable
      :options="navigatorOptions"
      :page-stack="pageStack"
      @fetchData="fetchData"
      @push-page="push"
      @pop-page="$emit('pop-page')"
      @toggleMainMenu="$emit('toggleMainMenu')"
      @refreshContent="rfct">
    </v-ons-navigator>
  </v-ons-page>
</template>

<script>
import Landing from './Landing'
import { appData } from '../data.js'

export default {
  name: 'home',
  props: {
    pageStack: Array,
  },
  data () {
    return {
      navigatorOptions: {animation: 'slide'}
    }
  },
  methods: {
    push(view) {
      this.$emit('push-page', view);
    },
    fetchData(file, callback) {
      this.$emit('fetchData', file, callback);
    },
    rfct(callback) {
      this.$emit('refreshContent', callback);
    }
  },
  created() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  * {
    box-sizing: border-box;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
  }

  .header div {
    max-width: 200px;
    width: 100%;
    background-color: green;
    padding: 20px;
    text-align: center;
    border-radius: 40px;
    color: #FFF;
  }

  ons-list-title {
    text-transform: none;
  }

  ons-list-title:not(:first-of-type) {
    margin-top: 30px;
  }

  ons-card {
    text-align: center;
    flex: 1 1 40%;
  }

  ons-card img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Navigator.vue